// extracted by mini-css-extract-plugin
module.exports = {"panel_detail_row":"aboutUs_panel_detail_row__7VFrE","space_reserved_space_buttons":"aboutUs_space_reserved_space_buttons__3KyxE","container":"aboutUs_container__1Cnl5"};